/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;justify-content:center;align-items:center;width:1.458em;height:1.458em;border-radius:5rem;box-shadow:0 .3125rem .75rem 0 rgba(0,0,0,.1);background-size:cover;background-position:center;text-transform:uppercase;color:#fff;font-size:3.5em;font-weight:500;margin:.3125rem}"];
export { styles as styles };
